module.exports = __webpack_public_path__ + "img/sintesis.7d88cf39.svg";